import { apiClient } from '@/lib/api-client'
import {
  transformAuthUser,
  type AuthUser,
  type UserResponse,
} from './types'

export type LoginPayload = {
  username: string
  password: string
}

export type LoginResponse = {
  access_token: string
  refresh_token?: string | null
  token_type: string
}

export const login = async ({
  username,
  password,
}: LoginPayload): Promise<LoginResponse> => {
  const { data } = await apiClient.post<LoginResponse>('/auth/login', {
    username,
    password,
  })
  return data
}

export const getCurrentUser = async (): Promise<AuthUser> => {
  const { data } = await apiClient.get<UserResponse>('/auth/me')
  return transformAuthUser(data)
}

// Sign-up types and function
export type SignUpPayload = {
  company_name: string
  email: string
  password: string
  full_name?: string
  timezone?: string
}

export type SignUpResponse = {
  message: string
  organization_id: number
  user_id: number
}

export const signup = async (payload: SignUpPayload): Promise<SignUpResponse> => {
  const { data } = await apiClient.post<SignUpResponse>('/signup/', payload)
  return data
}
